import FactorApi from "./FactorApi";

export default FactorApi;
